import { render, staticRenderFns } from "./recommendLoading.vue?vue&type=template&id=40a6b56c"
import script from "./recommendLoading.vue?vue&type=script&lang=js"
export * from "./recommendLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports